import { Component, input, output } from '@angular/core';
import { TitleLibComponent } from '@components/atoms';

@Component({
  selector: 'lib-selectable-service-card',
  standalone: true,
  imports: [TitleLibComponent],
  templateUrl: './selectable-service-card.component.html',
  styleUrls: ['./selectable-service-card.component.scss'],
})
export class SelectableServiceCardComponent {
  isSelected = input<boolean>(false);
  title = input.required<string>();
  price = input.required<string>();
  actionText = input.required<string>();
  actionTextClicked = output<void>();
  cardClicked = output<void>();

  onInfoRowClick(event: Event) {
    event.stopPropagation();
    this.actionTextClicked.emit();
  }

  onCardClick() {
    this.cardClicked.emit();
  }
}
